import script from "./sign-up-modified.vue?vue&type=script&setup=true&lang=js"
export * from "./sign-up-modified.vue?vue&type=script&setup=true&lang=js"

import "./sign-up-modified.vue?vue&type=style&index=0&id=03714909&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03714909"]])

export default __exports__